module.exports = __webpack_public_path__ + "static/media/Saleschannel_Logotype_RGB_Black.d1ab704e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Saleschannel_Logotype_RGB_Black.svg
// module id = 1280
// module chunks = 0